import React from 'react';
import styled from '@emotion/styled';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';

export const PreviewTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

type Props = React.PropsWithChildren<{
  className?: Argument;
}>;
export const PreviewWrapper: React.FC<Props> = ({ className, children }) => (
  <div
    className={cs(
      'bbk-preview-wrapper',
      'tw-relative tw-box-border tw-overflow-hidden',
      'tw-min-w-96 tw-rounded',
      '[&>div]:tw-rounded [&>div]:tw-shadow-md',
      '[&_.bbk-loss-components-grid-item]:tw-w-auto',
      className
    )}
  >
    {children}
  </div>
);

export const PreviewOverlay = styled.div`
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
`;
